/* eslint react-hooks/exhaustive-deps: "warn" */
import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './FddChallenges.module.scss';

type Translate = (key: string) => string;

const getChallenges = (t: Translate) => [
  {
    num: '01',
    title: t("The filings aren't standardised at all."),
    subtitle: t('Every jurisdiction has its own format.'),
    answer: t(
      'A German HGB filing, a French liasse fiscale and a UK abridged set share no schema. Each line resolves to the same field, with the original filing still attached to it.',
    ),
  },
  {
    num: '02',
    title: t('The registers publish the filing, not the data.'),
    subtitle: t('Not every filing is born digital.'),
    answer: t(
      'A German HGB filing, a French liasse fiscale and a UK abridged set share no schema. Each line resolves to the same field, with the original filing still attached to it.',
    ),
  },
  {
    num: '03',
    title: t('The filings are in the local language.'),
    subtitle: t('Captions resolved across languages and scripts.'),
    answer: t(
      "Umsatzerlöse, chiffre d'affaires and turnover are one line in three languages. A register will not tell you that. We do it once, so you never do it again.",
    ),
  },
  {
    num: '04',
    title: t('Update frequency differs country by country.'),
    subtitle: t("We track each register's cadence and re-read daily."),
    answer: t('Deadlines, filing windows and publication lags are set by the register, not by your review calendar.'),
  },
];

export const FddChallenges = () => {
  const { t } = useInt();
  const challenges = getChallenges(t);

  return (
    <Section background="#0E121C" className={styles.root}>
      <div className={styles.head}>
        <TitleBlock
          title={t('Building the same balance sheet across countries means solving the same problem twice.')}
          description={t(
            'Accounts are filed by format, not by function. A German HGB filing, a French liasse fiscale and a UK abridged set have nothing in common.',
          )}
          theme="dark"
          align="left"
        />
      </div>
      <div className={styles.list}>
        {challenges.map((c) => (
          <div key={c.num} className={styles.row}>
            <div className={styles.colNum}>{c.num}</div>
            <div className={styles.colTitle}>
              <span className={styles.challengeTitle}>{c.title}</span>
              <span className={styles.challengeSubtitle}>{c.subtitle}</span>
            </div>
            <div className={styles.colAnswer}>
              <p className={styles.answerText}>{c.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </Section>
  );
};
